'use strict';

// Services
import ListModel from 'common/components/list/listModel.service';
import { validAccess } from 'accessControl';
const __endpoints = require('endpoints.service');

export default class MarketRegionsList extends ListModel {
	constructor(reduxKey) {
		super(reduxKey);
		this.headers = [
			{
				name: 'name',
				type: 'string',
				canAdd: true,
				canEdit: true,
			},
			{
				name: 'sort_order',
				type: 'string',
				canAdd: true,
				canEdit: true,
			},
			{
				name: 'continent',
				type: 'select',
				canAdd: true,
				canEdit: true,

				reference: {
					key: 'name',
					list: '/administration/continents',
				},
			},
		];

		this.settings = {
			name: 'MarketRegionsList',
			canAdd: true,
			canEdit: true,
			canDelete: true,
			pageTitle: true,
			canManipulate: () => validAccess(undefined, ['Global BI Configuration']),
			translationPath: 'ADMINISTRATION.MARKET_REGIONS',
			endpoint: __endpoints.collection.administration.market_regions,
		};
		this.init();
		return this;
	}
}
